import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EdlTemplateTypeDTO } from '@edl-development/edl-common';

@Component({
    selector: 'edl-template-type-entry',
    templateUrl: './edl-template-type-entry.component.html',
    styleUrls: ['./edl-template-type-entry.component.scss']
})
export class EdlTemplateTypeEntryComponent implements OnInit {
    @Input() edlTemplateType?: EdlTemplateTypeDTO;
    @Input() set busy(value: boolean) {
        this._busy = value;
        this.setFormDisabled(value);
    }

    get busy(): boolean {
        return this._busy;
    }

    @Output() saveEvent: EventEmitter<EdlTemplateTypeDTO> = new EventEmitter<EdlTemplateTypeDTO>();
    @Output() deleteEvent: EventEmitter<string> = new EventEmitter<string>();

    private _busy: boolean = false;

    form: FormGroup;

    constructor(private formBuilder: FormBuilder) {}

    ngOnInit(): void {
        const canModify = this.edlTemplateType?.CanModify ?? true;

        this.form = this.formBuilder.group({
            Id: [this.edlTemplateType?.Id],
            Title: [this.edlTemplateType?.Title || ''],
            CanModify: [canModify],
        });

        this.setFormDisabled(this.busy);
    }

    private setFormDisabled(busy: boolean): void {
        if (this.edlTemplateType?.CanModify === false) {
            this.form?.disable();
        } else {
            busy ? this.form?.disable() : this.form?.enable();
        }
    }

    save = () => {
        if (this._busy) return;

        this.form.markAsPristine();
        this.saveEvent.emit(this.form.value);
    }

    delete = () => {
        if (this._busy) return;

        this.deleteEvent.emit(this.form.value.Id);
    }
}
